<template>
  <label class="flex items-center">
    <div :class="{'checkbox': !disabled, 'checkbox-disabled': disabled}">
      <input
          :checked="checked"
          :disabled="disabled"
          type="checkbox"
          v-on:change="$emit('change', $event.target.checked)"
      />
      <span :class="[typeClass]"></span>
    </div>
    <slot></slot>
  </label>
</template>

<script>
export default {
  model   : {
    prop : 'checked',
    event: 'change'
  },
  props   : {
    checked : Boolean,
    disabled: Boolean,
    type    : String
  },
  computed: {
    typeClass () {
      if (this.type) {
        return `cb-checkmark-${this.type}`
      } else {
        return 'cb-checkmark'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  width: 32px;
  height: 32px;
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    opacity: 0;
    cursor: pointer;
  }

  input:checked ~ .cb-checkmark {
    background: #f75f39;
    border: 1px solid #f75f39;
  }

  input:checked ~ .cb-checkmark:after {
    content: "";
    top: 5px;
    width: 12px;
    height: 17px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:hover {
    input ~ .cb-checkmark {
      background-color: #ccc;
    }

    input:active ~ .cb-checkmark {
      transform: scale(0.95);
    }

    input:checked ~ .cb-checkmark {
      background: #de5b3b;
      border: 1px solid #de5b3b;
    }
  }

  .cb-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 32px;
    width: 32px;
    background: rgba(152, 141, 155, 0.38);
    border-radius: 0.5rem;
    transition: all 0.2s;
  }

  .cb-checkmark:after {
    content: "+";
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -7px;
    font-weight: 500;
    color: white;
  }

  input:checked ~ .cb-checkmark-empty {
    background: #f75f39;
    border: 1px solid #f75f39;
  }

  input:checked ~ .cb-checkmark-empty:after {
    content: "";
    top: 5px;
    width: 12px;
    height: 17px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:hover {
    input ~ .cb-checkmark-empty {
      background-color: #ccc;
    }

    input:active ~ .cb-checkmark-empty {
      transform: scale(0.95);
    }

    input:checked ~ .cb-checkmark-empty {
      background: #de5b3b;
      border: 1px solid #de5b3b;
    }
  }

  .cb-checkmark-empty {
    position: absolute;
    top: 0;
    left: 0;
    height: 32px;
    width: 32px;
    border: 1px solid rgba(152, 141, 155, 0.38);
    border-radius: 0.5rem;
    transition: all 0.2s;
  }

  .cb-checkmark-empty:after {
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -7px;
    font-weight: 500;
    color: white;
  }
}

.checkbox-disabled {
  width: 32px;
  height: 32px;
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    opacity: 0;
    cursor: pointer;
  }

  input:checked ~ .cb-checkmark {
    background: #eadad6;
    border: 1px solid #ecdedb;
  }

  input:checked ~ .cb-checkmark:after {
    content: "";
    top: 5px;
    width: 12px;
    height: 17px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:hover {
    input ~ .cb-checkmark {
      background-color: #ccc;
    }

    input:active ~ .cb-checkmark {
      transform: scale(0.95);
    }

    input:checked ~ .cb-checkmark {
      background: #e0d0cd;
      border: 1px solid #dccac5;
    }
  }

  .cb-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 32px;
    width: 32px;
    background: rgba(152, 141, 155, 0.38);
    border-radius: 0.5rem;
    transition: all 0.2s;
  }

  .cb-checkmark:after {
    content: "+";
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -7px;
    font-weight: 500;
    color: white;
  }

  input:checked ~ .cb-checkmark-empty {
    background: #e1cfca;
    border: 1px solid #deccc7;
  }

  input:checked ~ .cb-checkmark-empty:after {
    content: "";
    top: 5px;
    width: 12px;
    height: 17px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:hover {
    input ~ .cb-checkmark-empty {
      background-color: #ccc;
    }

    input:active ~ .cb-checkmark-empty {
      transform: scale(0.95);
    }

    input:checked ~ .cb-checkmark-empty {
      background: #d9c6c1;
      border: 1px solid #dcc9c4;
    }
  }

  .cb-checkmark-empty {
    position: absolute;
    top: 0;
    left: 0;
    height: 32px;
    width: 32px;
    border: 1px solid rgba(152, 141, 155, 0.38);
    border-radius: 0.5rem;
    transition: all 0.2s;
  }

  .cb-checkmark-empty:after {
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -7px;
    font-weight: 500;
    color: white;
  }
}
</style>
